import React from 'react';
import PropTypes from 'prop-types';
import { useClassName, useWindowSize } from 'common/hooks';
import './progress-bar.less';

const ProgressBar = ({ totalSteps, currentStep, stepName, classes, size }) => {
  const classNames = useClassName('ProgressBar');
  const percentage = (currentStep * 100) / totalSteps;
  const { isMobile } = useWindowSize();
  return (
    <div className={classNames('container')}>
      {Boolean(stepName) && !isMobile && (
        <p
          className={classNames(
            'step-name'
          )}>{`Step ${currentStep} of ${totalSteps}: ${stepName}`}</p>
      )}
      <div className={`${classNames(['bar', `bar-${size}`])} ${classes}`}>
        <div
          className={classNames('progress')}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  stepName: PropTypes.string,
  classes: PropTypes.string,
  size: PropTypes.oneOf(['big', 'medium', 'small']),
};

ProgressBar.defaultProps = {
  size: 'medium',
};

export default ProgressBar;
